<template>
  <div v-if="devices?.length">
    <div class="row monospaced">
      <div class="col-12 col-sm-6" v-for="device in devices" :key="device.id">
        <div
          class="card mb-2"
          :class="{ 'border-primary': device.id === selectedId }"
          style="cursor: pointer;"
          @click="selectDevice(device)"
        >
          <div class="card-body p-2">
            <div class="d-flex align-items-center">
              <div class="me-2 flex-shrink-0">
                <span style="font-size: 2rem;">{{ device.emoji }}</span>
              </div>
              <div style="text-align: left;" class="flex-grow-1 overflow-hidden">
                <h6 class="card-title mb-0 text-truncate"><b>{{ device.name }}</b></h6>
                <small class="card-text text-muted text-truncate d-block">{{ device.location }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceSelector',
  props: {
    devices: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      selectedId: null
    }
  },
  methods: {
    selectDevice(device) {
      this.selectedId = device.id;
      this.$emit('device-selected', device);
    }
  }
}
</script>